import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Remodelaciones',
    href: '#remodelaciones'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-169">
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center" data-id="element-170">
        <a href="#inicio" className="flex items-center gap-2 z-50" data-id="element-171">
          <img src="https://i.imgur.com/2fq6zum.png" alt="Innova Pools & Systems Logo" className={`transition-all duration-300 ${isScrolled ? 'h-12' : 'h-16 drop-shadow-lg'}`} data-id="element-172" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-173">
          <ul className="flex gap-6" data-id="element-174">
            {navLinks.map(link => <li key={link.name} data-id="element-175">
                <a href={link.href} className={`font-medium transition-colors hover:text-pool-500 ${isScrolled ? 'text-gray-700' : 'text-white drop-shadow-md'}`} data-id="element-176">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="#contacto" className="bg-gold-500 hover:bg-gold-600 text-white font-semibold py-2.5 px-6 rounded-full transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-177">
            Agende su Inspección Gratuita
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className={`lg:hidden z-50 p-2 rounded-md ${isScrolled || mobileMenuOpen ? 'text-gray-800' : 'text-white'}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-178">
          {mobileMenuOpen ? <X size={28} data-id="element-179" /> : <Menu size={28} data-id="element-180" />}
        </button>

        {/* Mobile Nav */}
        <AnimatePresence data-id="element-181">
          {mobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="absolute top-0 left-0 right-0 bg-white shadow-xl pt-24 pb-8 px-6 flex flex-col gap-6 lg:hidden" data-id="element-182">
              <ul className="flex flex-col gap-4 text-center" data-id="element-183">
                {navLinks.map(link => <li key={link.name} data-id="element-184">
                    <a href={link.href} className="text-lg font-medium text-gray-800 hover:text-pool-500 block py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-185">
                      {link.name}
                    </a>
                  </li>)}
              </ul>
              <a href="#contacto" onClick={() => setMobileMenuOpen(false)} className="bg-gold-500 hover:bg-gold-600 text-white font-semibold py-3 px-6 rounded-full text-center shadow-md" data-id="element-186">
                Agende su Inspección Gratuita
              </a>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}